export function DataCache(dataToCache) {
    this.time = Date.now();
    this.cache = dataToCache;
}